import { message } from 'ant-design-vue'
import { type ImageOption, transImageResource } from '@xmov/oss'
import { COLLECTION_MAP } from './constant'
import { videoExt } from '~/components/resource/constant'
import type { Tag } from '~/api/interface'

// import Placeholder from '@/assets/png/placeholder.png'

// 深拷贝
export const deepClone = (obj: any) => {
  // 创建一个新的空对象用于存储深拷贝后的属性
  const newObj: any = {}

  // 遍历原始对象的属性
  for (const key in obj) {
    // 检查属性是否是对象类型
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      // 递归调用 cloneDeep 方法进行深拷贝
      newObj[key] = deepClone(obj[key])
    } else {
      // 直接复制属性值
      newObj[key] = obj[key]
    }
  }

  return newObj
}

/**
 * 获取UUID
 * @param number
 * @return {String}
 */
// export const uuid = (size = 21) => {
//   return window.crypto
//     .getRandomValues(new Uint8Array(size))
//     .reduce((id, byte) => {
//       byte &= 63
//       if (byte < 36) {
//         id += byte.toString(36)
//       } else if (byte < 62) {
//         id += (byte - 26).toString(36).toUpperCase()
//       } else if (byte > 62) {
//         id += '-'
//       } else {
//         id += '_'
//       }

//       return id
//     }, '')
// }

export function uuid() {
  let d = new Date().getTime()

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

const amountOptions = {
  style: 'currency',
  currency: 'CNY',
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
}
/**
 * 金额格式化
 * @param amount 金额
 * @returns
 */
export const amountFormat = (
  amount: number,
  locales = 'zh',
  options = amountOptions
): string => {
  return amount.toLocaleString(locales, options)
}

// 数值转千分位
export const turnThousand = (num: number) => {
  return num.toLocaleString('en-us')
}
// 手机号返回中间****
export const formatPhone = (phone: string) => {
  if (!phone) {
    return
  }

  return phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
}

const TB_ATOM = Math.pow(1024, 2)
const GB_ATOM = Math.pow(1024, 1)

export const formatFileSize = (size: number): string => {
  if (size >= TB_ATOM) {
    return `${Math.floor(size / TB_ATOM)}TB`
  } else if (size > GB_ATOM) {
    return `${Math.floor(size / GB_ATOM)}GB`
  } else {
    return `${size}MB`
  }
}

/**
 * 格式化文件大小
 * @param originalSize 原文件大小
 * @returns
 */
export const getFormateFileSize = (
  originalSize: number,
  round?: boolean
): string => {
  if (!originalSize) {
    return '0'
  }

  const isRound = round ?? true
  const UNIT_MAP = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const index = Math.floor(Math.log(originalSize) / Math.log(1024))
  const formateSize = originalSize / Math.pow(1024, index)
  const size = isRound ? Math.floor(formateSize) : formateSize.toFixed(2)
  return size + UNIT_MAP[index]
}

export const getUrlParams = (url: string) => {
  const urlStr = url.split('?')[1]
  const urlSearchParams = new URLSearchParams(urlStr)
  const result = Object.fromEntries(urlSearchParams.entries())
  return result
}

/**
 * 下载文件
 * @param url 文件地址
 * @param fileName
 */
export const downloadFile = (url: string | string[], fileName = '文件') => {
  if (Array.isArray(url)) {
    for (const [index, value] of url.entries()) {
      downloadVideoFile(value, `${fileName}-${index}`)
    }
  } else {
    const a: HTMLAnchorElement = document.createElement('a')
    document.body.appendChild(a)
    a.download = fileName
    a.href = url
    document.body.appendChild(a)
    a.click() // 点击a标签，进行下载
    document.body.removeChild(a) // 移除URL 对象
  }
}

/**
 * 下载视频
 * @param url 文件地址
 * @param fileName
 */
export const downloadVideoFile = async (url: string, name: string) => {
  // console.log(url, 'ddd')
  const response = await fetch(url)
  const blob = await response.blob()
  const blobUrl = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = name + '.' + url.split('.').pop()?.split('?')[0]
  a.click()
  a.remove()
  setTimeout(() => {
    window.URL.revokeObjectURL(blobUrl)
  })
}

export const downloadFileFromUrl = (
  url: string,
  item: any,
  onprocess: (
    r: number,
    t: number,
    id: number,
    status?: string,
    msg?: string
  ) => void,
  // onCancel,
  onCancel: (id: string, callback: any) => void
) => {
  const { $t } = useNuxtApp()

  const decodeUrl = decodeURIComponent(url)
  if (!navigator.onLine) {
    onprocess(
      0,
      0,
      item.id,
      'fail',
      $t('wang-luo-duan-kai-le-qing-jian-cha-wang-luo')
    )
    return
  }
  if (!url) {
    onprocess(0, 0, item.id, 'fail', $t('xia-zai-lian-jie-wu-xiao'))
    return
  }
  const controller = new AbortController()
  const { signal } = controller

  onCancel(item.id, controller)
  onprocess(0, 0, item.id, 'wait', $t('deng-dai-xia-zai'))
  return fetch(decodeUrl, { signal })
    .then((res) => {
      if (res.ok) {
        return res
      }

      onprocess(0, 0, item.id, 'fail', $t('xia-zai-chu-cuo'))
      return Promise.reject(res)
    })
    .then(async (response) => {
      const reader = (response.body as ReadableStream<Uint8Array>).getReader()

      // 文件总长度
      if (!(response && response.headers)) {
        return response.blob()
      }

      // @ts-ignore
      const contentLength = +response.headers.get('content-length') || 0
      if (!contentLength) {
        return response.blob()
      }

      let receivedLength = 0
      const chunks = []
      while (true) {
        const { done, value } = await reader.read()

        if (done) {
          break
        }

        chunks.push(value)
        receivedLength += value.length
        onprocess(receivedLength, contentLength, item.id)
      }
      return new Blob(chunks)
    })
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = item.title + '.' + url.split('.').pop()?.split('?')[0]
      a.click()
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl)
      })
    })
    .catch((e: any) => {
      if (
        e?.toString() === 'AbortError: BodyStreamBuffer was aborted' ||
        e?.toString() === 'AbortError: The user aborted a request.'
      ) {
        return null
      }

      message.error('下载出错了，请检查网络')
    })
}

/* 回收站为作品、成片、成片模板、资源的集合；
 * 回收站里的每条数据都要求后端给出对应的类型，否则无法区分；
 * @param tab 作用于作品。成片。成片模板
 * @param mediaType 作用与资源以及回收站
 * @returns
 */
export const getCardType = (tab: number, mediaType: number) => {
  // 作品、成片、成片模板
  if (
    [
      COLLECTION_MAP.OPUS,
      COLLECTION_MAP.PIECES,
      COLLECTION_MAP.PIECES_TEMPLATE,
    ].includes(tab)
  ) {
    return CARD_TYPE.MAIN
  } else {
    if (
      [
        RESOURCE_TYPE.MATERIAL,
        RESOURCE_TYPE.FONT,
        RESOURCE_TYPE.HEAD,
        RESOURCE_TYPE.END,
        RESOURCE_TYPE.PASTER,
        RESOURCE_TYPE.STUDIO,
        RESOURCE_TYPE.PERSON,
      ].includes(mediaType)
    ) {
      return CARD_TYPE.MATERIAL
    }

    if ([RESOURCE_TYPE.MUSIC, RESOURCE_TYPE.SOUND_EFFECT].includes(mediaType)) {
      return CARD_TYPE.MUSIC
    }

    // if ([RESOURCE_TYPE.PASTER].includes(mediaType)) {
    //   return CARD_TYPE.PURE;
    // }
  }

  return CARD_TYPE.PURE
}

// 我的收藏资源区分
export const getCollectionCardType = (_: number, mediaType: number) => {
  if ([RESOURCE_TYPE_CONFIG.TIMBRE].includes(mediaType)) {
    return CARD_TYPE.TIMBRE
  }

  if (
    [RESOURCE_TYPE_CONFIG.MUSIC, RESOURCE_TYPE_CONFIG.SOUND_EFFECT].includes(
      mediaType
    )
  ) {
    return CARD_TYPE.MUSIC
  }

  if ([RESOURCE_TYPE_CONFIG.MATERIAL].includes(mediaType)) {
    return CARD_TYPE.MATERIAL
  }

  return CARD_TYPE.MAIN
}

export const sleep = (time = 1000) =>
  new Promise((resolve) => setTimeout(resolve, time))

export const base64ConvertFile = (urlData: string) => {
  const arr = urlData.split(',')
  const type = arr?.[0]?.match(/:(.*?);/)?.[1]
  const fileExt = type?.split('/')[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], 'coverImg.' + fileExt, { type })
}

const TARGET_FOR_FIRST_LEVEL: Partial<Record<COLLECTION_MAP, TARGET_FROM>> = {
  [COLLECTION_MAP.OPUS]: TARGET_FROM.Project,
  [COLLECTION_MAP.PIECES]: TARGET_FROM.EV,
  [COLLECTION_MAP.PIECES_TEMPLATE]: TARGET_FROM.Template,
}

const TARGET_FOR_SECOND_LEVEL: Partial<Record<RESOURCE_TYPE, TARGET_FROM>> = {
  [RESOURCE_TYPE.STUDIO]: TARGET_FROM.Studio,
  [RESOURCE_TYPE.PERSON]: TARGET_FROM.VirtualHuman,
  [RESOURCE_TYPE.TIMBRE]: TARGET_FROM.Timbre,
  [RESOURCE_TYPE.SUBTITLE_TEMPLATE]: TARGET_FROM.SubtitleTemplate,
  [RESOURCE_TYPE.MATERIAL]: TARGET_FROM.Material,
  [RESOURCE_TYPE.FONT]: TARGET_FROM.Font,
  [RESOURCE_TYPE.MUSIC]: TARGET_FROM.BGM,
  [RESOURCE_TYPE.SOUND_EFFECT]: TARGET_FROM.Audio,
  [RESOURCE_TYPE.PASTER]: TARGET_FROM.Sticker,
  [RESOURCE_TYPE.HEAD]: TARGET_FROM.Title,
  [RESOURCE_TYPE.END]: TARGET_FROM.Credit,
}

export const getTargetForEventTracking = (
  tab: COLLECTION_MAP,
  second?: RESOURCE_TYPE
) => {
  if (tab !== COLLECTION_MAP.SOURCE) {
    return TARGET_FOR_FIRST_LEVEL[tab]
  }

  if (second !== undefined) {
    return TARGET_FOR_SECOND_LEVEL[second!]
  }

  return undefined
}

function toUrl(url: URL, hasOrigin: boolean = true) {
  return hasOrigin
    ? url.toString()
    : `${url.pathname}?${url.searchParams.toString()}`
}

/**
 * 图片资源转换
 * @export
 */
export const transformImage = (
  file_url?: string,
  param?: {
    height?: number
    width?: number
  }
) => {
  const url = file_url

  if (!url) {
    return ''
  }

  const hasOrigin = url.startsWith('http')

  const parseUrl = new URL(url, 'https://temp')

  const suffix = (url.split('?')[0].split('.').pop() || '').toLowerCase()

  if (url && url.indexOf('x-oss-process') > 0) {
    return toUrl(parseUrl, hasOrigin)
  }

  if (suffix === 'gif' || videoExt.includes(`.${suffix}`)) {
    return toUrl(parseUrl, hasOrigin)
  }

  if (param?.height || param?.width) {
    const h = param?.height ? `h_${param.height},` : ''
    const w = param?.width ? `w_${param.width},` : ''
    parseUrl.searchParams.append(
      'x-oss-process',
      `image/resize,${w}${h}m_lfit/format,webp`
    )
  } else {
    parseUrl.searchParams.append('x-oss-process', 'image/format,webp')
  }

  return toUrl(parseUrl, hasOrigin)
}

export const getQueryString = (name: string) => {
  const url = useRequestURL()
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = url.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }

  return null
}

export function randomString(length: number) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }

  return result
}

function removeTrailingSlash(path: string) {
  if (path.endsWith('/')) {
    return path.slice(0, -1)
  }
  return path
}

export function routePathMatch(source: string, currentPath: string) {
  return removeTrailingSlash(source) === removeTrailingSlash(currentPath)
}

/**
 * @description 图片合法性校验
 */
const _check = (buffer: Uint8Array, headers: number[], options?: any) => {
  options = {
    offset: 0,
    ...options,
  }
  for (const [index, header] of headers.entries()) {
    // If a bitmask is set
    if (options.mask) {
      // If header doesn't equal `buf` with bits masked off
      if (header !== (options.mask[index] & buffer[index + options.offset])) {
        return false
      }
    } else if (header !== buffer[index + options.offset]) {
      return false
    }
  }
  return true
}
/**
 * @description 获取图片文件格式
 */
export const fileParse = (arrayBuffer: ArrayBuffer) => {
  const buffer = new Uint8Array(arrayBuffer)
  const check = (headers: number[], options?: any) =>
    _check(buffer, headers, options)
  if (check([0xff, 0xd8, 0xff]) && !check([0xf7], { offset: 3 })) {
    return {
      ext: 'jpg',
      mime: 'image/jpeg',
    }
  }
  if (check([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])) {
    return {
      ext: 'png',
      mime: 'image/png',
    }
  }
  if (check([0x47, 0x49, 0x46])) {
    return {
      ext: 'gif',
      mime: 'image/gif',
    }
  }
  return undefined
}

export const checkFileType = (file: File) => {
  const accept = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif']
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = fileParse(reader.result as ArrayBuffer)
      return resolve(!!(result?.mime && accept.includes(result.mime)))
    }
    reader.readAsArrayBuffer(file as Blob)
  })
}

export const copyToClipboard = (text: string) => {
  const { $t } = useNuxtApp()
  // 创建text area
  const textArea: HTMLTextAreaElement = document.createElement('textarea')
  textArea.value = text
  // 使text area不在viewport，同时设置不可见
  textArea.style.position = 'absolute'
  textArea.style.opacity = '0'
  textArea.style.left = '-999999px'
  textArea.style.top = '-999999px'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  return new Promise<void>((resolve, reject) => {
    // 执行复制命令并移除文本框
    document.execCommand('copy')
      ? resolve()
      : reject(new Error($t('fu-zhi-shi-bai')))
    textArea.remove()
  })
}

/**
 * 新建a标签
 * @export
 */
export const createALink = (url: string, id: string, target?: string) => {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', target || '_blank')
  a.setAttribute('id', id)
  // 防止反复添加
  if (!document.getElementById(id)) {
    document.body.appendChild(a)
  }
  a.click()
}

/**
 * 用于限制重定向拦截跳转域名，防止 redirect hackers
 * @param {string} link - 需要重定向的链接
 * @returns {void}
 */
export const redirectTo = (link: string) => {
  const homeRoute = useHomeRoute()
  const router = useRouter()

  // 防止重定向跳转
  if (!link) {
    navigateTo(homeRoute)
    return
  }
  const url = decodeURIComponent(link)
  const redirectUrl = new URL(url)

  const isIp =
    /^(((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))))$/.test(
      redirectUrl.hostname
    )

  const whiteList = [
    '.youyan.xyz',
    '.youyan3d.com',
    '.rendora.ai',
    '.xmov.ai',
    'youyan3d.bookan.com.cn',
    'yy.magook.hk',
  ]

  const isSafeHost = whiteList.some((v) => redirectUrl.host.endsWith(v))

  if (isIp || isSafeHost) {
    const resolved = router.resolve({ path: '/' + redirectUrl.pathname })
    if (resolved.matched.length > 0 && redirectUrl.pathname !== '/') {
      const path = redirectUrl.pathname + redirectUrl.search
      return navigateTo(path)
    }
    location.href = url
    return
  }

  navigateTo(homeRoute)
}

export function registerUnloadEvent(callback: () => void) {
  window.addEventListener('beforeunload', callback)
}

export const OSS_PATH = 'https://official-site.youyan.xyz/youyan/official_site'
export const EN_OSS_PATH = 'https://fe.rendora.ai/youyan/official_site'

export const nameToImageOssUrl = (name: string, option?: ImageOption) => {
  return transImageResource(
    `${isGlobalVersion() ? EN_OSS_PATH : OSS_PATH}/images/${name}`,
    option || {
      format: 'webp',
    },
    true
  ) as string
}

export const nameToVideoUrl = (name: string) => {
  return `${isGlobalVersion() ? EN_OSS_PATH : OSS_PATH}/video/${name}`
}

// 高亮命中文案
export const checkHightLight = (text: string, keyword: string[]) => {
  if (!keyword?.length) {
    return text
  }
  if (!text) {
    return
  }
  let newText = text
  keyword.map((item) => {
    const reg = new RegExp(item, 'gi')
    newText = newText.replace(reg, '<span class="text-primary">$&</span>')
    return text
  })
  return newText
}

// 浏览器下载视频
export const downloadVideo = (url: string) => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  document.body.appendChild(iframe)
  iframe.onload = () => {
    document.body.removeChild(iframe)
  }
}

export const setTags = (
  arr?: Tag[],
  parent?: string,
  map?: Ref<Record<string, TagInfo>>
) => {
  arr?.forEach((item) => {
    item.ids = `${parent ? parent + ':' : ''}${item.level},${item.tag_id}`
    map && (map.value[item.ids] = item)
    if (item.children?.length) {
      setTags(item.children, item.ids, map)
    }
  })
}
